document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.sticky-add-to-cart').forEach(function (stickyBar) {
    const sectionId = stickyBar.getAttribute('data-section-id');

    const productInfo = document.getElementById(
      'MainProduct-' + sectionId
    );

    const stickyButton = stickyBar.querySelector(
      '[data-sticky-add-to-cart]'
    );

    const stickyPrice = stickyBar.querySelector(
      '.sticky-add-to-cart__price'
    );

    let buttonObserver = null;

    function getMainButton() {
      return document.getElementById(
        'ProductSubmitButton-' + sectionId
      );
    }

    if (!stickyButton) {
      console.warn('Sticky Add to Cart: sticky button not found');
      return;
    }

    /*
     * SHOW / HIDE
     */
    function updateStickyBar() {
      const mainButton = getMainButton();

      if (!mainButton) return;

      const buttonRect = mainButton.getBoundingClientRect();

      if (buttonRect.bottom <= 0) {
        stickyBar.classList.add('is-visible');
      } else {
        stickyBar.classList.remove('is-visible');
      }
    }

    /*
     * SYNC STICKY BUTTON WITH MAIN BUTTON
     */
    function syncButton() {
      const mainButton = getMainButton();

      if (!mainButton) return;

      const isInCart = mainButton.classList.contains('is-in-cart');

      stickyButton.classList.toggle('is-in-cart', isInCart);

      stickyButton.disabled =
        mainButton.disabled ||
        mainButton.getAttribute('aria-disabled') === 'true';

      const mainAddText = mainButton.querySelector(
        '.product-cart-state--add'
      );

      const stickyAddText = stickyButton.querySelector(
        '.sticky-cart-state--add'
      );

      if (mainAddText && stickyAddText) {
        stickyAddText.textContent = mainAddText.textContent.trim();
      }
    }

    /*
     * OBSERVE CURRENT MAIN BUTTON
     *
     * Dawn can replace the button when variant changes,
     * so we reconnect the observer.
     */
    function observeMainButton() {
      const mainButton = getMainButton();

      if (!mainButton) return;

      if (buttonObserver) {
        buttonObserver.disconnect();
      }

      buttonObserver = new MutationObserver(function () {
        syncButton();
      });

      buttonObserver.observe(mainButton, {
        attributes: true,
        childList: true,
        subtree: true
      });
    }

    /*
     * MAIN PRODUCT PICKER -> STICKY ACTIVE VARIANT
     */
    function syncStickyVariantFromMainPicker() {
      if (!productInfo) return;

      const variantPicker = productInfo.querySelector(
        'variant-selects'
      );

      if (!variantPicker) return;

      const selectedValues = [];

      variantPicker
        .querySelectorAll('fieldset.product-form__input')
        .forEach(function (fieldset) {
          const checked = fieldset.querySelector(
            'input[type="radio"]:checked'
          );

          if (checked && checked.value) {
            selectedValues.push(checked.value.trim());
          }
        });

      variantPicker
        .querySelectorAll('.product-form__input--dropdown select')
        .forEach(function (select) {
          if (select.value) {
            selectedValues.push(select.value.trim());
          }
        });

      if (!selectedValues.length) return;

      const selectedVariantTitle = selectedValues.join(' / ');

      stickyBar
        .querySelectorAll('.sticky-add-to-cart__variant-link')
        .forEach(function (link) {
          const stickyVariantTitle = link.textContent.trim();

          const isActive =
            stickyVariantTitle === selectedVariantTitle;

          link.classList.toggle('is-active', isActive);

          if (isActive) {
            link.setAttribute('aria-current', 'true');
          } else {
            link.removeAttribute('aria-current');
          }
        });
    }

    /*
     * MAIN PRICE -> STICKY PRICE
     */
    function syncStickyPrice() {
      if (!stickyPrice) return;

      const mainPrice = document.getElementById(
        'price-' + sectionId
      );

      if (!mainPrice) return;

      const salePrice = mainPrice.querySelector(
        '.price__sale .price-item--sale'
      );

      const regularPrice = mainPrice.querySelector(
        '.price__regular .price-item--regular'
      );

      const fallbackPrice = mainPrice.querySelector(
        '.price-item'
      );

      const priceText =
        salePrice?.textContent.trim() ||
        regularPrice?.textContent.trim() ||
        fallbackPrice?.textContent.trim();

      if (priceText) {
        stickyPrice.textContent = priceText;
      }
    }

    /*
     * STICKY BUTTON CLICK
     */
    stickyButton.addEventListener('click', function () {
      const mainButton = getMainButton();

      if (!mainButton) return;

      /*
       * Already in cart -> go to cart
       */
      if (stickyButton.classList.contains('is-in-cart')) {
        window.location.href = '/cart';
        return;
      }

      /*
       * Normal state -> click Dawn main Add to Cart
       */
      if (
        mainButton.disabled ||
        mainButton.getAttribute('aria-disabled') === 'true'
      ) {
        return;
      }

      mainButton.click();
    });

    /*
     * VARIANT CHANGE
     */
    if (productInfo) {
      productInfo.addEventListener('change', function (event) {
        if (!event.target.closest('variant-selects')) {
          return;
        }

        syncStickyVariantFromMainPicker();

        setTimeout(function () {
          observeMainButton();
          syncStickyVariantFromMainPicker();
          syncStickyPrice();
          syncButton();
          updateStickyBar();
        }, 100);

        setTimeout(function () {
          observeMainButton();
          syncStickyVariantFromMainPicker();
          syncStickyPrice();
          syncButton();
          updateStickyBar();
        }, 300);

        setTimeout(function () {
          observeMainButton();
          syncStickyPrice();
          syncButton();
          updateStickyBar();
        }, 600);
      });
    }

    /*
     * CART UPDATE
     */
    if (
      typeof subscribe === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined'
    ) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(syncButton, 100);
        setTimeout(syncButton, 500);
        setTimeout(syncButton, 1000);
      });
    }

    window.addEventListener('scroll', updateStickyBar, {
      passive: true
    });

    window.addEventListener('resize', updateStickyBar);

    window.addEventListener('pageshow', function () {
      observeMainButton();
      syncButton();
      syncStickyPrice();
      updateStickyBar();
    });

    /*
     * INITIAL STATE
     */
    observeMainButton();
    syncButton();
    syncStickyVariantFromMainPicker();
    syncStickyPrice();
    updateStickyBar();
  });
});